var exports = {
  "q": "GifIndicator.module__indicator___a1U2SE",
};

module.exports = exports;
